import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./boilerplate/reportWebVitals";
import "@shopify/polaris/dist/styles.css";
import "./PolarisCustom.css";

import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

import common_en from "./translations/en/common.json";
import { Provider } from "react-redux";
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import PortalReducer from "./store/reducers/Portal";
import { setAutoFreeze } from "immer";

import { LDProvider } from "launchdarkly-react-client-sdk";

setAutoFreeze(false);

const rootReducer = combineReducers({
    portal: PortalReducer
});

const composeEnhancers =
    typeof window === "object" &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
              trace: true,
              traceLimit: 25
          })
        : compose;

const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk))
);

i18next.init({
    interpolation: { escapeValue: false }, // React already does escaping
    lng: "en", // language to use
    resources: {
        en: {
            common: common_en // 'common' is our custom namespace
        }
    }
});

const clientSideID = process.env.REACT_APP_LD_CLIENT_SIDE_ID ?? "";

ReactDOM.render(
    <React.StrictMode>
        <LDProvider clientSideID={clientSideID}>
            <I18nextProvider i18n={i18next}>
                <Provider store={store}>
                    <App />
                </Provider>
            </I18nextProvider>
        </LDProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
